import classNames from 'classnames';
import { useParams } from 'react-router-dom';
import { Button, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';

import React, { useContext, useEffect, useState } from 'react';
import { headTbl } from '../../../data/tables';
import LoadinSpin from '../../ui/LoadinSpin';
import { useGetDta } from '../../../hooks/useGetDta';
import { AuthContext } from '../../../auth/AuthContext';
import Table from '../../Table';
import ModSaldo from './ModSaldo';
import Confirmation from '../../ui/Confirmation';
import { checkAccess } from '../../../helpers/details';

const SaldosUs = ({ activo, activeTab }) => {
    const { id } = useParams();

    let idR = atob(id);
    const { auth } = useContext(AuthContext);
  const permisos = checkAccess('Facturación', auth.accesos);
    const {
        fact_agregar_saldo,
        fact_editar_saldo, fact_eliminar_saldo,
      } = permisos.functions

    const [show, setShow] = useState(false);
    const [showd, setShowd] = useState(false);
    const [info, setInfo] = useState({});
    const [item, setItem] = useState();

    const { loading, data, getInfo } = useGetDta(`usertools/saldos/${idR}`);

    const openEdit = (ol) => {
        setItem(ol);
        setShow(true);
    };
    useEffect(() => {
        getInfo(`usertools/saldos/${idR}`);
    }, [activeTab, activo, idR]);

    const ActionColumn = ({ row }) => {
        const item = { id: row.original.id, monto: row.original.monto, descri: row.original.descri };
        return (
            <>
                <>
                    {fact_editar_saldo && (
                        <OverlayTrigger
                            className="action-icon "
                            placement="left"
                            overlay={<Tooltip id="overlay-example"> Editar</Tooltip>}>
                            <i className="mdi mdi-pencil mdi-18px " onClick={() => openEdit(item)}></i>
                        </OverlayTrigger>
                    )}

                    {fact_eliminar_saldo && (
                        <OverlayTrigger placement="left" overlay={<Tooltip id="overlay-example">Borrar</Tooltip>}>
                            <i className="mdi mdi-delete mdi-18px mx-2 " onClick={() => dele(row.original.id)}></i>
                        </OverlayTrigger>
                    )}
                </>
            </>
        );
    };
    const dele = (id) => {
        setInfo({ id, type: 'SALDO' });
        setShowd(true);
    };
    const StatusColm = ({ row }) => {
        return (
            <span
                className={classNames('badge', {
                    'bg-success': row.original.estado === 1,
                    'bg-danger': row.original.estado === 0,
                })}>
                {row.original.estado ? 'PAGADO' : 'PENDIENTE'}
            </span>
        );
    };
    const TipoColumn = ({ row }) => {
        return (
            <>
                <span className="text-center">${row.original.monto}</span>
            </>
        );
    };
    const Column = ({ row }) => {
        return (
            <>
                <span className="text-center">{row.original.fac_desti}</span>
            </>
        );
    };
    const columns = [
        {
            Header: 'Pago origen',
            accessor: 'fac_origen',
            sort: true,
        },

        {
            Header: 'Pago destino',
            accessor: 'fec_desti',
            sort: true,
            Cell: Column,
        },
        {
            Header: 'Monto',
            accessor: 'monto',
            sort: true,
            Cell: TipoColumn,
        },
        {
            Header: 'Fecha',
            accessor: 'fecha',
            sort: true,
        },

        {
            Header: 'Descripción',
            accessor: 'descri',
            sort: true,
        },
        {
            Header: 'Estado',
            accessor: 'estado',
            sort: true,
            Cell: StatusColm,
        },
        {
            Header: 'Acción',
            accessor: 'action',
            sort: false,
            classes: 'table-action',
            Cell: ActionColumn,
        },
    ];
    const sizePerPageList = headTbl(data.length);
    if (loading) return <LoadinSpin />;
    return (
        <div className="mt-3">
            {' '}
            <Row className="mb-2">
                <Col xs="auto">
                    {fact_agregar_saldo && (
                        <Button type="button" onClick={() => openEdit({})}>
                            <b>+</b> Nuevo
                        </Button>
                    )}
                </Col>
            </Row>
            <Table
                columns={columns}
                data={data}
                pageSize={25}
                sizePerPageList={sizePerPageList}
                isSortable={true}
                pagination={true}
                isSearchable={true}
                searchBoxClass="mb-2"
            />
            <ModSaldo show={show} onClose={() => setShow(!show)} callBk={getInfo} item={item} />
            <Confirmation show={showd} toggle={() => setShowd(false)} info={info} callBk={getInfo} />
        </div>
    );
};

export default SaldosUs;
